import marcaNegativa from '@/assets/brand/_provisorio/marca-negativa.png';
import marcaPositiva from '@/assets/brand/_provisorio/marca-positiva.png';
import simbolo from '@/assets/brand/_provisorio/simbolo.png';

import estilos from './Logo.module.css';

/**
 * Unico ponto da aplicacao que referencia o asset da marca.
 *
 * Especificacao V3.1, item 7.1 e task T04b: nenhum componente de negocio
 * importa arquivo de imagem direto. Trocar o asset oficial e substituir o
 * arquivo e ajustar os tres imports acima.
 *
 * Os arquivos atuais sao provisorios, extraidos do PDF do guia. Ver
 * src/assets/brand/_provisorio/README.md e a Decisao 03.
 *
 * Regras de uso da marca (guia, paginas 30 a 39):
 * - `negativa` somente sobre superficie escura;
 * - `simbolo` pode ser usado sozinho como grafismo;
 * - proporcao, cores e lado do simbolo nao podem ser alterados.
 */

export type VarianteDaMarca = 'positiva' | 'negativa' | 'simbolo';

export interface LogoProps {
  variante?: VarianteDaMarca;
  /** Altura renderizada. A largura acompanha para preservar a proporcao. */
  altura?: number;
  /**
   * Texto alternativo. Use `''` quando a marca for decorativa e o nome do
   * produto ja estiver escrito ao lado, para nao repetir no leitor de tela.
   */
  textoAlternativo?: string;
  className?: string;
}

const origens: Record<VarianteDaMarca, string> = {
  positiva: marcaPositiva,
  negativa: marcaNegativa,
  simbolo: simbolo,
};

const proporcoes: Record<VarianteDaMarca, number> = {
  positiva: 2434 / 1068,
  negativa: 2417 / 1022,
  simbolo: 1051 / 1068,
};

export function Logo({
  variante = 'positiva',
  altura = 32,
  textoAlternativo = 'FAP Online',
  className,
}: LogoProps) {
  const largura = Math.round(altura * proporcoes[variante]);

  return (
    <img
      src={origens[variante]}
      alt={textoAlternativo}
      width={largura}
      height={altura}
      className={className === undefined ? estilos.logo : `${estilos.logo} ${className}`}
      // A marca nunca deve ser distorcida (guia, pagina 39: uso indevido).
      style={{ height: `${String(altura)}px`, width: `${String(largura)}px` }}
      decoding="async"
    />
  );
}
